<template>
  <b-modal v-model="modalVisible" centered hide-footer title="匯出酒桶Log">
    <template #default>
      <div>
        <div class="h4 mb-3">請輸入要匯出的時間區間</div>
        <b-form-group
          label="起始日期"
          label-for="start-date-input"
        >
          <b-form-input id="start-date-input" type="date" v-model="startDate"></b-form-input>
        </b-form-group>
        <b-form-group
          label="結束日期"
          label-for="end-date-input"
        >
          <b-form-input id="end-date-input" type="date" v-model="endDate"></b-form-input>
        </b-form-group>

        <div>
          <b-button variant="primary" class="w-100" @click="exportExcelClicked">匯出</b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import { mapActions } from "vuex";
import moment from 'moment';

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegLogExportModal',
  data() {
    return {
      startDate: '',
      endDate: '',
    };
  },
  components: {
  },
  mounted() {
    const m = moment();
    this.endDate = m.format('YYYY-MM-DD');
    this.startDate = m.subtract(90, 'day').format('YYYY-MM-DD');
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

  },
  watch: {
    
  },
  methods: {
    ...mapActions(['showMsgModal', 'appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),
    exportExcelClicked() {
      this.handleAsyncTask(async () => {
        await this.$store.dispatch('api/getKegLogExcelPromise', {
          startDate: this.startDate,
          endDate: this.endDate,
        });
        this.$bvModal.msgBoxOk(`資料匯出完成!`, {
          title: '匯出成功',
          size: 'sm',
          centered: true
        }).then(() => {
          this.modalVisible = false;
        });
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

</style>
